'use client';

import React from 'react';
import { useAuth } from "../../../contexts/AuthContext";
import { AuthGuard } from "../../auth/components/AuthGuard";
import { Header } from "../../landing/components/Header";
import { EventForm } from '../components/EventForm';
import { useNavigate } from 'react-router-dom';
import { ImportFromLumaModal } from '../components/ImportFromLumaModal';
import { Helmet } from 'react-helmet-async'

const CreateEventPage: React.FC = () => {
  const { isLoading, isAuthenticated, isInitialized, user, profile } = useAuth();
  const navigate = useNavigate();
  // ...existing code...

  const [isImportModalOpen, setIsImportModalOpen] = React.useState(false);

  const handleEventSubmit = (eventId: string) => {
    // Redirigir a la página del evento con parámetro de éxito
    navigate(`/events/${eventId}?created=true`);
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };
  
  return (
    <>
    <Helmet>
      <title>Crear evento | Punta Tech Meetup</title>
      <meta name="description" content="Creá un nuevo evento y compartilo con la comunidad de Punta Tech Meetup." />
    </Helmet>
    <AuthGuard
      requireAuth={true} 
      isLoading={isLoading} 
      isAuthenticated={isAuthenticated} 
      isInitialized={isInitialized}
    >
      <div className="min-h-screen overflow-x-hidden brand-gradient-surface">
        <Header  theme='dark' onSignInClick={() => {}} onImportFromLumaClick={() => setIsImportModalOpen(true)} importButtonStyle="black" />
        <div className="pt-20">
          <EventForm 
            mode="create"
            onSubmit={handleEventSubmit}
            onCancel={handleCancel}
          />
        </div>
        <ImportFromLumaModal 
          isOpen={isImportModalOpen}
          onClose={() => setIsImportModalOpen(false)}
          userId={user?.id || ''}
          userProfile={{ name: profile?.full_name, email: user?.email || undefined, avatarUrl: profile?.avatar_url || '' }}
          onImported={(eventId) => {
            setIsImportModalOpen(false)
            navigate(`/events/${eventId}`)
          }}
        />
      </div>
    </AuthGuard>
    </>
  );
};

export default CreateEventPage;
